import CryptoJS from "crypto-js";

export function EncryptedOBJ(data)
{
    const cipher = CryptoJS.AES.encrypt(JSON.stringify(data), CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_KEY), {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_IV), // parse the IV 
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    })
    
    // e.g. B6AeMHPHkEe7/KHsZ6TW/Q==
    return cipher.toString()
}
export function DecryptedOBJ(data)
{
    try
    {
        const cipher = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_KEY), {
            iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_IV), // parse the IV 
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        })
        
        if(cipher)
        {
            // e.g. B6AeMHPHkEe7/KHsZ6TW/Q==
            return JSON.parse(cipher.toString(CryptoJS.enc.Utf8));
        }else
        {
            clearSessionAndCallback(); 
        }
    }
    catch(error)
    {
        clearSessionAndCallback();
    }
}

export function EncryptedText(data)
{
    const cipher = CryptoJS.AES.encrypt(data, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_KEY), {
        iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_IV), // parse the IV 
        padding: CryptoJS.pad.Pkcs7,
        mode: CryptoJS.mode.CBC
    })
    
    // e.g. B6AeMHPHkEe7/KHsZ6TW/Q==
    return cipher.toString()
}
export function DecryptedText(data)
{
    try {
        const cipher = CryptoJS.AES.decrypt(data, CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_KEY), {
            iv: CryptoJS.enc.Utf8.parse(process.env.REACT_APP_ENCRYPT_DATA_IV), // parse the IV 
            padding: CryptoJS.pad.Pkcs7,
            mode: CryptoJS.mode.CBC
        })
        
        if(cipher)
        {
            // e.g. B6AeMHPHkEe7/KHsZ6TW/Q==
            return cipher.toString(CryptoJS.enc.Utf8);
        }else
        {
            clearSessionAndCallback();
        }
    }catch(error)
    {
        clearSessionAndCallback();
    }
}

function clearSessionAndCallback()
{
    let callbackURL = localStorage.getItem(process.env.REACT_APP_ENC_NAME_SIGNED_CALLBACK_URL);
    if(!!callbackURL)
    {
        let callbackURLDec = DecryptedText(callbackURL);
        console.log('callbackURLDec: ', callbackURLDec);
        if(callbackURLDec.indexOf('/ref') >= 0)
        {
            let refRedirect = !!localStorage.getItem('refredirect') ? DecryptedText(localStorage.getItem('refredirect')) : null;
            let newCallbackURL = callbackURLDec.replace('/ref', `/${refRedirect}`)
            let path = newCallbackURL;
            localStorage.clear();
            location.href = path; 
        }else
        {
            let path = callbackURLDec;
            localStorage.clear();
            location.href = path;
        }
    }  
}